import { useCallback, useState } from 'react';

/**
 * Hook permettant d'enregistrer des données dans le stockage local.
 * @param keyName
 * @param defaultValue
 */
export const useLocalStorage = <T,>(keyName: string, defaultValue: T): [T, (newValue: T) => void] => {
    // Récupération d'une valeur dans le stockage
    const [storedValue, setStoredValue] = useState<T>(() => {
        try {
            const value = globalThis.localStorage.getItem(keyName);

            if (value) {
                return JSON.parse(value) as T;
            } else {
                globalThis.localStorage.setItem(keyName, JSON.stringify(defaultValue));
                return defaultValue;
            }
        } catch (_err) {
            return defaultValue;
        }
    });

    // Enregistrement d'une valeur dans le stockage
    const setValue = useCallback(
        (newValue: T) => {
            try {
                globalThis.localStorage.setItem(keyName, JSON.stringify(newValue));
            } catch (_err) {}
            setStoredValue(newValue);
        },
        [keyName]
    );

    return [storedValue, setValue];
};

/**
 * Méthode qui permet de récupérer la valeur d'une clé dans le local storage
 * @param keyName
 */
export const getValueLocalStorage = (keyName: string) => {
    const value = globalThis.localStorage.getItem(keyName);
    if (value) {
        return JSON.parse(value);
    } else {
        globalThis.localStorage.setItem(keyName, JSON.stringify(null));
        return null;
    }
};
